import { render, staticRenderFns } from "./VDaySwitch.vue?vue&type=template&id=ea066c4e&"
import script from "./VDaySwitch.vue?vue&type=script&lang=js&"
export * from "./VDaySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports